import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [], // [{ id, role: 'user' | 'assistant', content, timestamp }]
  loading: false,
  error: null,
  isOpen: false,
};

const chatReducer = createSlice({
  name: "chat",
  initialState,
  reducers: {
    toggleChat: (state) => {
      state.isOpen = !state.isOpen;
    },
    openChat: (state) => {
      state.isOpen = true;
    },
    closeChat: (state) => {
      state.isOpen = false;
    },
    // payload: { message: string }
    sendMessage: (state, action) => {
      state.loading = true;
      state.error = null;
      state.messages.push({
        id: `${Date.now()}-user`,
        role: "user",
        content: action.payload.message,
        timestamp: new Date().toISOString(),
      });
    },
    // payload: { reply: string }
    sendMessageSuccess: (state, action) => {
      state.loading = false;
      state.messages.push({
        id: `${Date.now()}-assistant`,
        role: "assistant",
        content: action.payload.reply,
        timestamp: new Date().toISOString(),
      });
    },
    // payload: { detail, code }
    sendMessageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearChat: (state) => {
      state.messages = [];
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  toggleChat,
  openChat,
  closeChat,
  sendMessage,
  sendMessageSuccess,
  sendMessageFailure,
  clearChat,
  clearError,
} = chatReducer.actions;

// Selectors
export const selectChatMessages = (state) => state.chat.messages;
export const selectChatLoading = (state) => state.chat.loading;
export const selectChatError = (state) => state.chat.error;
export const selectChatIsOpen = (state) => state.chat.isOpen;

export default chatReducer.reducer;